import gql from "graphql-tag";

export default gql`
  mutation CreateRequest(
    $title: String!
    $description: String!
    $priority: Priority
    $customerId: ID!
  ) {
    createRequest(
      title: $title
      description: $description
      priority: $priority
      customerId: $customerId
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/CreateRequest.ts